export default [
  {
    path: "productos",
    name: "products",
    redirect: { name: "products-list" },
    children: [
      {
        path: "",
        name: "products-list",
        component: () => import("@/modules/products/views/ProductsList.vue"),
      },
      {
        path: ":id",
        name: "product-item",
        component: () => import("@/modules/products/views/ProductShow.vue"),
      },
    ],
  },
];
